import React from "react";

function Features({index, bgFromIndex}) {
  return (
    <section id="features" className="features-section" style={{backgroundColor: bgFromIndex(index)}}>
            <div className="section-header"></div>
      <h2>Features</h2>
      <ul>
        <li>
          🧠 Puzzles for All Levels: From easy to expert, find the right
          challenge that suits your skill level.
        </li>
        <li>
          ⏲️ Time Attack Mode: Test your speed and set new records in this
          exciting timed challenge.
        </li>
        <li>
          🛠️ Hint System: Stuck on a tricky puzzle? Use smart hints to guide
          your next move without spoiling the fun.
        </li>
        {/* <li>
          🎨 Customizable Themes: Play in style! Choose from beautiful themes to
          enhance your gameplay experience.
        </li> */}
        <li>
          🌐 Offline Play: Solve puzzles anytime, anywhere—even without an
          internet connection.
        </li>
        <li>
          📊 Daily Challenges & Achievements: Keep the fun going with new
          puzzles every day, and track your progress with achievements!
        </li>
      </ul>
    </section>
  );
}

export default Features;
